export default __webpack_public_path__ + "d2d884f4511fa15fe27403b296813f27.svg";